import MultiDataObject from '../../../common/model/MultiDataObject';

export default class SettingValues extends MultiDataObject {
  useDynamicSchema() {
    return true;
  }

  useInheritedMetadataRules() {
    return true;
  }

  getDtoSchema() {
    return {
      propertyNameField: 'identifier',
      propertyValueField: 'value',
      secondaryPropertyNames: [
        'lastUpdatedTime',
        'lastUpdatedBy'
      ]
    };
  }
}